import React from "react";
import { useGlobalStore } from "../../utils/global";

export default function GlobalLoading() {
  const { loading } = useGlobalStore();
  return (
    <div className={`modal-loading${loading ? " open" : ""}`}>
      <div className="content-modal-loading">
        <figure>
          <img src={require("../../ui/img/loading.gif")} alt="Loading" />
        </figure>
      </div>
    </div>
  );
}
